var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBuyNftSolid = function SvgBuyNftSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.236 1.612c-.639.857-.78 2.057-1.064 4.457L.938 8.055c-.38 3.22-.57 4.83.13 5.998a4 4 0 0 0 .99 1.115C3.138 16 4.758 16 8 16s4.863 0 5.942-.832a4 4 0 0 0 .99-1.115c.7-1.169.51-2.779.13-5.998l-.234-1.986c-.284-2.4-.425-3.6-1.063-4.457A4 4 0 0 0 12.55.533C11.625 0 10.416 0 8.001 0 5.583 0 4.375 0 3.448.533a4 4 0 0 0-1.213 1.079ZM6.5 4.5a1.5 1.5 0 1 0 3 0V4a1 1 0 0 1 2 0v.5a3.5 3.5 0 1 1-7 0V4a1 1 0 0 1 2 0v.5Z",
    clipRule: "evenodd"
  })));
};
export default SvgBuyNftSolid;